<ng-container *transloco="let t">
<ng-template #hoi>
  <form #hoiForm="ngForm" novalidate id="hoiForm" name="hoiForm">
    @if (!isRefinance) {
      <div class="row mb-5 mt-6 rounded"
          [ngClass]="{
            'is-invalid' : haveHoiQuoteQuestion && haveHoiQuoteQuestion.touched && haveHoiQuoteQuestion.invalid,
            'border' : haveHoiQuoteQuestion && haveHoiQuoteQuestion.touched && haveHoiQuoteQuestion.invalid,
            'p-4' : haveHoiQuoteQuestion && haveHoiQuoteQuestion.touched && haveHoiQuoteQuestion.invalid,
            'border-danger' : haveHoiQuoteQuestion && haveHoiQuoteQuestion.touched && haveHoiQuoteQuestion.invalid
          }">
          <div class="col-md-6 col-sm-12 fs-6 text-dark mb-3" style="padding-top: 4px;">{{ t('wizard.hoi.doYouHaveQuote', { address: subjectPropertyAddress }) }}
          </div>
          <div class="col-md-2 col-sm-12 mb-3">
            <div class="d-flex">
              <div class="form-check form-check-custom form-check-solid">
                <input
                  class="form-check-input"
                  name="haveHoiQuote"
                  required
                  [value]="true"
                  type="radio"
                  id="yesHoiQuote"
                  [(ngModel)]="haveHoiQuote" #haveHoiQuoteQuestion="ngModel"
                  (ngModelChange)="onHaveHoiQuoteQuestionAnswered()"/>
                <label style="padding-right: 6px;" class="form-check-label" for="yesHoiQuote">{{ t('common.yes') }}</label>
              </div>
              <div class="form-check form-check-custom form-check-solid ms-8">
                <input
                  class="form-check-input"
                  name="haveHoiQuote"
                  required
                  [value]="false"
                  type="radio"
                  id="noHoiQuote"
                  [(ngModel)]="haveHoiQuote" #haveHoiQuoteQuestion="ngModel"
                  (ngModelChange)="onHaveHoiQuoteQuestionAnswered()"/>
                <label style="padding-right: 6px;" class="form-check-label" for="noHoiQuote">{{ t('common.no') }}</label>
              </div>
            </div>
          </div>
      </div>
      <div class="invalid-feedback">{{ t('wizard.hoi.pleaseAnswerQuestion') }}</div>
    }

    <div class="row mb-5" [hidden]="!haveHoiQuote && !isRefinance">
      <div class="col-md-8" [ngClass]="{'is-invalid' : hoi && hoi.touched && hoi.invalid}">
        <label class="align-items-center fs-6 fw-bold form-label mb-2">
          <span class="">{{enterHoiAmountQuestionText}}</span>
        </label>
        <div class="position-relative d-flex">
          <input style="min-width: 85px" type="text" class="form-control form-control-solid" mask="separator" thousandSeparator="," inputmode="decimal" prefix="$"
            [(ngModel)]="hoiAmountEntered" placeholder="" name="hoiQuoteAmount" #hoi="ngModel"
            (ngModelChange)="onHoiAmountChanged()"
            #hoiAmountInput
            (focus)="isHoiAmountVisited = true;"
            [required]="haveHoiQuote || isRefinance"
            [ngClass]="{'is-invalid' : hoi && hoi.touched && hoi.invalid}"/>

          <select class="form-select form-select-solid ms-4 flex-grow-1" style="width: 150px" data-control="select2" name="period" #period="ngModel"
            [ngClass]="{'is-invalid' : hoi && hoi.touched && hoi.invalid}"
            [(ngModel)]="paymentPeriod"
            (ngModelChange)="onPaymentPeriodChanged()">
            <option value="PerYear">{{ t('wizard.hoi.perYear') }}</option>
            <option value="PerMonth">{{ t('wizard.hoi.perMonth') }}</option>
          </select>
          <label [hidden]="!calculatedHoiAmount"
            style="min-width: 200px"
            class="align-items-center fs-6 fw-bold form-label mt-4 ms-3">{{ calculatedHoiAmount | currency}}/{{paymentPeriod === 'PerYear' ? t('wizard.hoi.month') : t('wizard.hoi.year')}}
          </label>
        </div>
      </div>
      <div class="invalid-feedback">{{hoiAmountValidationErrorMessage}}</div>
    </div>

    @if (isHoiEnabled && (calculatedHoiAmount || haveHoiQuote === false)) {
      <div class="row mb-5 mt-6 rounded"
          [ngClass]="{
            'is-invalid' : showMoreHoiOptionsQuestion && showMoreHoiOptionsQuestion.touched && showMoreHoiOptionsQuestion.invalid,
            'border' : showMoreHoiOptionsQuestion && showMoreHoiOptionsQuestion.touched && showMoreHoiOptionsQuestion.invalid,
            'border-danger' : showMoreHoiOptionsQuestion && showMoreHoiOptionsQuestion.touched && showMoreHoiOptionsQuestion.invalid
          }">
          <div class="col-md-8 col-sm-12 fs-6 text-dark mb-3" style="padding-top: 4px;">{{showMeOptionsMessage}}
          </div>
          <div class="col-md-4 col-sm-12 mb-3">
            <div class="d-flex">
              <div class="form-check form-check-custom form-check-solid">
                <input
                  class="form-check-input"
                  name="showMoreHoiOptions"
                  required
                  [value]="true"
                  type="radio"
                  id="aYes"
                  [(ngModel)]="showMoreHoiOptions" #showMoreHoiOptionsQuestion="ngModel"/>
                <label style="padding-right: 6px;" class="form-check-label" for="aYes">{{ t('wizard.hoi.yesShowMe') }}</label>
              </div>
              <div class="form-check form-check-custom form-check-solid ms-8">
                <input
                  class="form-check-input"
                  name="showMoreHoiOptions"
                  required
                  [value]="false"
                  type="radio"
                  id="aNo"
                  [(ngModel)]="showMoreHoiOptions" #showMoreHoiOptionsQuestion="ngModel"/>
                <label style="padding-right: 6px;" class="form-check-label" for="aNo">{{ t('wizard.hoi.noNotInterested') }}</label>
              </div>
            </div>
          </div>
          @if (!isRefinance) {
            <div class="col-md-12 col-sm-12 mb-3" style="font-style:italic">
              {{ t('wizard.hoi.canAlwaysDecline') }}
            </div>
          }
      </div>
    }
  </form>
</ng-template>

<wizard-step-template [stepMainTemplate]="hoi" [step]="step" [stepComponent]="this"></wizard-step-template>
</ng-container>
